import { useContext } from 'react'

import { ShopAndRuntimeConfigContext } from 'views/components/templates/helpers'
import { PublicConfig, PageProperties } from 'server/shop-config/types'

// Utils are used within FC, so it is fine to use `useContext` here
export const getPublicConfig = (): PublicConfig => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { publicConfig } = useContext(ShopAndRuntimeConfigContext)

  return publicConfig as PublicConfig
}

export const getPageProperties = (): PageProperties => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pageProperties } = useContext(ShopAndRuntimeConfigContext)

  return pageProperties as PageProperties
}
